module.exports = __webpack_public_path__ + "images/status-wait.c34b95b7.png";